export const PhoneNumberSelector = 'phoneNumber';
export const MobileCountryCodeSelector = 'mobileCountryCode';
